export default __webpack_public_path__ + "static/media/EW1211A.fd6fa92a.jpg";